export enum NotificationResourceTypeEnum {
  EVENT_PARTICIPANT_ID = 'EVENT_PARTICIPANT_ID',
  EVENT_ID = 'EVENT_ID',
  EVENT_NAME = 'EVENT_NAME',
  STRUCTURE_ID = 'STRUCTURE_ID',
  STRUCTURE_NAME = 'STRUCTURE_NAME',
  RELATION_ID = 'RELATION_ID',
  CONVERSATION_ID = 'CONVERSATION_ID',
}
